import FormikInput from 'components/formikFields/input'
import Header from 'components/headers/wallet'
import { Form, Formik } from 'formik'
import React, { useState } from 'react'
import { Schema } from '../addNewUser/utilities'
import useGetCards from 'pages/loans/withDraw/hooks/useGetCards'
import DotsLoading from 'components/loadings/dotsLoading'

import { useParams } from 'react-router-dom'
import useGetMoneyPoolManagementByWebKey from './hooks/useGetMoneyPoolManagement'
import useSetAddUserByLink from './hooks/useSetAddUserByLink'

interface ISelectUser {
    name: string
    id: undefined | number
    memberId: undefined | number
}

export default function JoinUserByLink() {
    const [selectedGuarantor, setSelectedGuarantor] = useState<ISelectUser>()
    const [GuarantorId, setGuarantorId] = useState<undefined | number>()
    const [selectedBankNumber, setSelectedBankNumber] = useState<number>(0)
    const [isOpenRecommender, setIsOpenRecommender] = useState<boolean>(false)
    const { web_key } = useParams()
    const {
        moneyPoolManagement,
        isLoadingMoneypoolManagement,
        error,
        isError,
    } = useGetMoneyPoolManagementByWebKey(web_key)
    const [selectedRecommender, setSelectedRecommender] =
        useState<ISelectUser>()
    const [RecommenderId, setRecommenderId] = useState<undefined | number>()
    useGetCards(
        selectedGuarantor?.id,
        selectedGuarantor?.memberId,
        setSelectedBankNumber
    )
    useGetCards(
        selectedRecommender?.id,
        selectedRecommender?.memberId,
        setSelectedBankNumber
    )
    const { mutate } = useSetAddUserByLink()

    if (isError) {
        return null // Do not render the form if there is an error
    }
    return (
        <>
            <Formik
                initialValues={{
                    moneyPoolName: moneyPoolManagement?.moneypool_name,
                    moneypoolShareValueAmount: moneyPoolManagement?.share_value_amount,
                    phone_number: '',
                    number_of_shares: '1',
                    first_name: '',
                    last_name: '',
                }}
                validationSchema={Schema}
                onSubmit={async (values) => {
                    const payload: IAddNewUserToFundPayload = {
                        moneyPool: moneyPoolManagement?.moneypool_id,
                        phone_number: values.phone_number,
                        first_name: values.first_name,
                        last_name: values.last_name,
                        number_of_shares: values.number_of_shares,
                        recommender: selectedRecommender?.id,
                        guarantor: selectedGuarantor?.id,
                    }
                    mutate(payload)
                }}
            >
                <Form>
                    <>
                        {isLoadingMoneypoolManagement ? (
                            <DotsLoading />
                        ) : (
                            <div>
                                <div className=" h-screen flex flex-col">
                                    <div className=" grow-0">
                                        <Header
                                            title={`فرم عضویت در صندوق قرض الحسنه
                                             ${moneyPoolManagement?.moneypool_name}`}
                                        />
                                    </div>
                                    <div className=" grow mt-32">
                                        <div className=" mx-3 mt-3 text-sm font-normal">
                                            <FormikInput
                                                type="number"
                                                label="شماره موبایل"
                                                name="phone_number"
                                                placeholder=""
                                                className="text-sm font-normal"
                                                isGray
                                                min={0}
                                            />
                                        </div>
                                        <div className=" mx-3 mt-4 text-sm font-normal grid grid-cols-3 gap-2">
                                            <div className=" col-span-1">
                                                <FormikInput
                                                    type="text"
                                                    label="نام"
                                                    name="first_name"
                                                    placeholder=""
                                                    className="text-sm font-normal"
                                                    isGray
                                                />
                                            </div>
                                            <div className=" col-span-2">
                                                <FormikInput
                                                    type="text"
                                                    label="نام خانوادگی"
                                                    name="last_name"
                                                    placeholder=""
                                                    className="text-sm font-normal"
                                                    isGray
                                                />
                                            </div>
                                        </div>
                                        <div className=" mx-3 mt-4 text-sm font-normal text-center items-center">
                                            <div className=" col-span-1">
                                                <FormikInput
                                                    type="number"
                                                    label="حق عضویت پایه (تومان)"
                                                    name="number_of_shares"
                                                    placeholder=""
                                                    className="text-sm font-normal"
                                                    isGray
                                                    value={
                                                        moneyPoolManagement?.share_value_amount
                                                    }
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                        <div className=" mx-3 mt-4 text-sm font-normal text-center items-center">
                                            <div className=" col-span-1">
                                                <FormikInput
                                                    type="number"
                                                    label="تعداد سهم"
                                                    name="number_of_shares"
                                                    placeholder=""
                                                    className="text-sm font-normal"
                                                    isGray
                                                    min={0}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className=" grow-0 mx-4">
                                        <button
                                            className=" w-full rounded-2xl bg-green-1 text-white py-3 my-3"
                                            type="submit"
                                        >
                                            ثبت
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                </Form>
            </Formik>
        </>
    )
}
